import { render } from "./FintriviaHero.vue?vue&type=template&id=441078aa&scoped=true"
import script from "./FintriviaHero.vue?vue&type=script&lang=js"
export * from "./FintriviaHero.vue?vue&type=script&lang=js"

import "./FintriviaHero.vue?vue&type=style&index=0&id=441078aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441078aa"]])

export default __exports__